module.exports = __webpack_public_path__ + "static/media/tcm_icon.8306c030.png";